module.exports = __webpack_public_path__ + "img/icon_nav5.5ffb6579.a013b574.svg";